import { Box, Skeleton } from "@mui/material";
import { ChatProcess } from "../types";
import { ChatProcessStatus } from "../types/chat";

type ChatWaitingMiddleProps = {
    assignProcess: ChatProcess;
    isPendingSession: boolean;
    isLoadingSession: boolean;
}
const ChatWaitingMiddle: React.FC<ChatWaitingMiddleProps> = ({ isPendingSession, assignProcess, isLoadingSession }) => {
    if (isLoadingSession || assignProcess.status === ChatProcessStatus.PENDING) {
        // create a random number between 100 and 200
        const randomNumber = () => Math.floor(Math.random() * 100) + 100;
        return (
            <Box display="flex" flexDirection="column" gap={2} height="100%">
                {Array.from({ length: 7 }).map((_, index) => (
                    <Box
                        key={index}
                        display="flex"
                        justifyContent={index % 2 === 0 ? "flex-start" : "flex-end"}
                    >
                        <Skeleton variant="rounded" width={randomNumber()} height={30} />
                    </Box>
                ))}
            </Box>
        )
    }
    return null;
};

export default ChatWaitingMiddle;